"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.apiWithoutErrorsHandler = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _codes = require("./codes");
var _handle401status = require("./handle401status.util");
var _toast = require("./toast");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_axios.default.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
_axios.default.defaults.withCredentials = true;
var apiWithoutErrorsHandler = _axios.default;
exports.apiWithoutErrorsHandler = apiWithoutErrorsHandler;
var instance = _axios.default.create();
instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    var _ref = error.response || {},
      data = _ref.data;
    var message = data.code && (0, _codes.replaceVals)(_codes.codes[data.code], data.params);
    switch (error.response.status) {
      case 401:
        (0, _handle401status.handle401status)();
        break;
      case 403:
        _toast.toast.error({
          title: 'Something went wrong',
          description: 'Access forbidden'
        });
        break;
      default:
        _toast.toast.error({
          title: 'Something went wrong',
          description: message || data.message || 'Please try again or contact support if the problem continues.'
        });
    }
  }
  return Promise.reject(error);
});
var _default = instance;
exports.default = _default;